import { Box, Typography } from "@mui/material";
import type { FeaturedMetric as FeaturedMetricData } from "../campaignTypes";
import { portalFont } from "../partnerTheme";

export default function FeaturedMetric({ metric }: { metric: FeaturedMetricData }) {
  return (
    <Box
      sx={{
        width: "100%",
        maxWidth: { xs: "100%", sm: 420 },
        p: { xs: 2, sm: 2.5, md: 3 },
        borderRadius: { xs: "20px", md: "var(--portal-radius)" },
        bgcolor: "rgba(18,20,23,0.92)",
        border: "1px solid color-mix(in srgb, var(--portal-accent) 45%, transparent)",
        backdropFilter: "blur(8px)",
      }}
    >
      <Typography
        sx={{
          fontFamily: portalFont,
          fontSize: "0.6875rem",
          fontWeight: 700,
          letterSpacing: "0.14em",
          textTransform: "uppercase",
          color: "color-mix(in srgb, var(--portal-accent) 75%, white)",
          mb: 1,
        }}
      >
        {metric.label}
      </Typography>
      <Typography
        sx={{
          fontFamily: portalFont,
          fontWeight: 700,
          color: "#fff",
          fontSize: { xs: "clamp(2rem, 10vw, 2.75rem)", sm: "clamp(2.25rem, 4vw + 1rem, 3.75rem)" },
          lineHeight: 1,
          letterSpacing: "-0.03em",
          mb: 1.25,
        }}
      >
        {metric.value}
      </Typography>
      <Typography
        sx={{
          fontFamily: portalFont,
          fontSize: { xs: "0.75rem", sm: "0.8125rem" },
          color: "rgba(255,255,255,0.92)",
          lineHeight: 1.5,
        }}
      >
        {metric.detail}
      </Typography>
    </Box>
  );
}
